import React, { useEffect, forwardRef, useImperativeHandle } from 'react'
import { getSiteEnv } from '../services/Utils';
import { logDownPayment } from '../services/Api';

const PortalOne = forwardRef(({ setIsLoading, setShowHomeMenu, setShowLoadingText, GoBack, pol, zip, env, GetPaymentData, paymentComplete, isDownPayment, amountPaid, paymentDate, confirmationNumber, quoteID, isModalReady, isTextToPay, isNotifications, sessionID }, ref) => {
    const $ = window.$

    async function portalOneContainer_portalOne_saveComplete(e, data) {
        const payment = await GetPaymentData(pol, zip, env);
        if (isModalReady && isTextToPay) {
            isNotifications.current = true
            LoadNotificationsModal(payment, sessionID.current)
        }
    }

    function portalOneContainer_portalOne_unload(e,data) {
        //show loading wheel until decision is made
        setShowLoadingText(false)
        setIsLoading(false)
        GoBack();
    }

    function portalOneContainer_portalOne_error(e,data) {
        //show loading wheel until decision is made
        console.log(e);
        console.log(data);
        setShowLoadingText(false)
        setIsLoading(false)
        GoBack();
    }

    function portalOneContainer_portalOne_paymentComplete(e, data) {
        paymentComplete.current = true
        if (isDownPayment.current === true) {
            amountPaid.current = data.paymentAmount
            paymentDate.current = data.transactionDate
            confirmationNumber.current = data.transactionId
            quoteID.current = data.clientReferenceData1
            logDownPayment(quoteID.current,zip,data.transactionId,data.paymentAmount,data.transactionDate,env);
        }
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://${env === "prod" ? "" : "stg"}portalone.processonepayments.com/Api/Api/Cdn/GenericModalV2/assets/js/PortalOne.js`;
        script.async = true;
        document.body.appendChild(script);
        $('#portalOneContainer').on('portalOne.saveComplete', portalOneContainer_portalOne_saveComplete);
        $('#portalOneContainer').on('portalOne.unload', portalOneContainer_portalOne_unload);
        $('#portalOneContainer').on('portalOne.error', portalOneContainer_portalOne_error);
        $('#portalOneContainer').on('portalOne.paymentComplete', portalOneContainer_portalOne_paymentComplete);
        return () => {
            document.body.removeChild(script);
            $('#portalOneContainer').off('portalOne.saveComplete', portalOneContainer_portalOne_saveComplete);
            $('#portalOneContainer').off('portalOne.unload', portalOneContainer_portalOne_unload);
            $('#portalOneContainer').off('portalOne.error', portalOneContainer_portalOne_error);
            $('#portalOneContainer').off('portalOne.paymentComplete', portalOneContainer_portalOne_paymentComplete);
        }
    }, [env])

    function LoadInactivePaymentModal(d, SessionID) {
        $('#portalOneContainer').portalOne();
        d.FullName = d.Fullname === null ? "" : d.FullName
        d.FirstName = d.FirstName === null ? "" : d.FirstName
        d.MiddleInitial = d.MiddleInitial === null ? "" : d.MiddleInitial
        d.LastName = d.LastName === null ? "" : d.LastName
        $('#portalOneContainer').data('portalOne').makePayment({
            'paymentCategory': 'UserSelect',
            'feeContext': 'PaymentWithFee',
            'amountContext': 'EnterAmountOnly',
            'billingZip': d.Zip,
            'billingAddressStreet': d.Address + " " + d.City + ", " + d.State,
            'policyHolderName': (d.PolState === "PA" ? d.FullName : d.FirstName + " " + (d.MiddleInitial.length > 0 ? d.MiddleInitial + ". " : "") + d.LastName),
            'clientReferenceData1': pol,
            'clientReferenceData3': d.PolState,
            'confirmationDisplay': 'true',
            'saveOption': 'Save',
            'accountGroupCode': 'FallsLake',
            'acknowledgmentRequired': 'true',
            'acceptCreditCards': 'true',
            'acceptPrepaidCards': 'true',
            'sessionId': SessionID
        });
        setIsLoading(false)
        setShowHomeMenu(false)
    }

    function LoadManagePaymentMethodsModal(d, SessionID) {
        $('#portalOneContainer').portalOne();
        $('#portalOneContainer').data('portalOne').managePaymentMethods({
            'customerId': d.CustomerID,
            'sessionId': SessionID,
            'acceptCreditCards': 'true',
            'acceptPrepaidCards': 'true',
            'paymentCategory': 'UserSelect',
            'loadingIndication': 'false'
        });
        setIsLoading(false)
        setShowHomeMenu(false)
    }

    function LoadNotificationsModal(d, SessionID) {
        console.log("Loading notifications modal...")
        $('#portalOneContainer').portalOne();
        const obj = {
            'externalCustomerId': pol,
            'userRole': 'insured',
            'customerID': d.CustomerID,
            'sessionId': SessionID
        }
        $('#portalOneContainer').data('portalOne').manageNotifications(obj);
        setIsLoading(false)
        setShowHomeMenu(false)
    }

    function LoadPaymentModal(d, SessionID, Pol = "") {
        console.log("Loading payment modal...")
        $('#portalOneContainer').portalOne();
        const obj = {
            'paymentCategory': ((Pol === "" ? pol : Pol).substring(0, 2) === 'AP' ? 'CreditCard' : 'UserSelect'),
            'feeContext': 'PaymentWithFee',
            'amountContext': (d.Amt === '0' || d.Amt === '0.00' || d.Amt === '' ? 'AmountDueOnly' : 'SelectAmount'), //'SelectAmount',
            'minAmountDue': (d.Amt === '0' || d.Amt === '0.00' || d.Amt === '' ? d.Bln : d.Amt),
            'maxAmountDue': d.Bln,
            'accountBalance': d.Bln,
            'billingZip': (d.Zip === '-1' ? d.PolZip : d.Zip),
            'billingAddressStreet': d.Address + " " + d.City + ", " + d.State,
            "policyHolderName": (d.PolState === "PA" ? d.FullName : d.FirstName + " " + (d.MiddleInitial != null ? d.MiddleInitial + ". " : "") + d.LastName),
            'clientReferenceData1': (Pol === "" ? pol : Pol),
            'clientReferenceData3': d.PolState,
            'confirmationDisplay': 'true',
            'saveOption': 'Save',
            'accountGroupCode': 'FallsLake',
            'acknowledgmentRequired': 'true',
            'acceptCreditCards': 'true',
            'acceptPrepaidCards': 'true',
            'customerId': d.CustomerID,
            'email': d.Email,
            'sessionId': SessionID,
            "operation": "makePayment"
        };
        $('#portalOneContainer').data('portalOne').makePayment(obj);
        setIsLoading(false)
        setShowHomeMenu(false)
    }

    useImperativeHandle(ref, () => ({
        LoadInactivePaymentModal,
        LoadManagePaymentMethodsModal,
        LoadNotificationsModal,
        LoadPaymentModal
    }))

    return (
        <>
            <div id="portalOneContainer"></div>
        </>
    )
})

export default PortalOne